// src/Redux/Slice/GeminiOCR.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';

// Base URL for your API
const BaseUrl = process.env.REACT_APP_API_URL;

// --- Asynchronous Thunks ---

// Fetch EInvoice EWay Setup Main Thunk
export const fetchEInvoiceEWaySetupMainData = createAsyncThunk(
    'GeminiOCR/fetchEInvoiceEWaySetupMainData',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/EInvoice_EWaySetupMain_view`);
            return response.data?.data || [];
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);

// Add EInvoice EWay Setup Main Thunk
export const EInvoice_EWaySetupMain_add = createAsyncThunk(
    'EinvoiceEwayBill/EInvoice_EWaySetupMain_add',
    async ({ values }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/EInvoice_EWaySetupMain_add`, values);

            return response.data?.data || [];
        } catch (error) {
            toast.error("Something went wrong while adding");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to add"
            );
        }
    }
);

// Update EInvoice EWay Setup Main Thunk
export const EInvoice_EWaySetupMain_Update = createAsyncThunk(
    'EinvoiceEwayBill/EInvoice_EWaySetupMain_Update',
    async ({ id, formData }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/EInvoice_EWaySetupMain_update/${id}`, formData);

            return response.data?.data || [];
        } catch (error) {
            toast.error("Something went wrong while updating");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to update"
            );
        }
    }
);

// Delete EInvoice EWay Setup Main Thunk
export const EInvoice_EWaySetupMain_Delete = createAsyncThunk(
    'EinvoiceEwayBill/EInvoice_EWaySetupMain_Delete',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/EInvoice_EWaySetupMain_delete/${id}`);

            return response.data;
        } catch (error) {
            toast.error("Something went wrong while deleting");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to delete"
            );
        }
    }
);


// Fetch EInvoice EWay Setup Detail Thunk
export const fetchEInvoiceEWaySetupDetail = createAsyncThunk(
    'EinvoiceEwayBill/fetchEInvoiceEWaySetupDetail',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/EInvoice_EWaySetupDetail_view`);
            return response.data?.data || [];
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);

// Add EInvoice EWay Setup Detail Thunk
export const EInvoice_EWaySetupDetail_add = createAsyncThunk(
    'EinvoiceEwayBill/EInvoice_EWaySetupDetail_add',
    async ({ values }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/EInvoice_EWaySetupDetail_add/${values.Provider}`, values);

            return response.data?.data || [];
        } catch (error) {
            toast.error("Something went wrong while adding");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to add"
            );
        }
    }
);

// Update EInvoice EWay Setup Detail Thunk
export const EInvoice_EWaySetupDetail_Update = createAsyncThunk(
    'EinvoiceEwayBill/EInvoice_EWaySetupDetail_Update',
    async ({ id, formData }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/EInvoice_EWaySetupDetail_update/${id}`, formData);

            return response.data?.data || [];
        } catch (error) {
            toast.error("Something went wrong while updating");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to update"
            );
        }
    }
);

// Delete EInvoice EWay Setup Detail Thunk
export const EInvoice_EWaySetupDetail_Delete = createAsyncThunk(
    'EinvoiceEwayBill/EInvoice_EWaySetupDetail_Delete',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/EInvoice_EWaySetupDetail_delete/${id}`);

            return response.data;
        } catch (error) {
            toast.error("Something went wrong while deleting");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to delete"
            );
        }
    }
);

// Fetch Einvoice Eway Setup Registration Thunk
export const fetchEinvoiceEwaySetupRegistration = createAsyncThunk(
    'EinvoiceEwayBill/fetchEinvoiceEwaySetupRegistration',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/EInvoice_EwayRegistration_view`);
            return response.data?.data || [];
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);

// Add Einvoice Eway Setup Registration Thunk
export const EInvoice_EwayRegistration_add = createAsyncThunk(
    'EinvoiceEwayBill/EInvoice_EwayRegistration_add',
    async ({ values, loginData }, { rejectWithValue }) => {
        try {
            const AdminID = loginData?.data?._id;
            const response = await axios.post(`${BaseUrl}/EInvoice_EwayRegistration_add/${AdminID}/${values?.ClientID}`, values);

            return response.data?.data || [];
        } catch (error) {
            toast.error("Something went wrong while adding registration");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to add registration"
            );
        }
    }
);

// Update Einvoice Eway Setup Registration Thunk
export const EInvoice_EwayRegistration_update = createAsyncThunk(
    'EinvoiceEwayBill/EInvoice_EwayRegistration_update',
    async ({ id, formData }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/EInvoice_EwayRegistration_update/${id}`, formData);

            return response.data?.data || [];
        } catch (error) {
            toast.error("Something went wrong while updating registration");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to update registration"
            );
        }
    }
);

// Delete Einvoice Eway Setup Registration Thunk
export const EInvoice_EwayRegistration_delete = createAsyncThunk(
    'EinvoiceEwayBill/EInvoice_EwayRegistration_delete',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/EInvoice_EwayRegistration_delete/${id}`);

            return response.data;
        } catch (error) {
            toast.error("Something went wrong while deleting registration");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to delete registration"
            );
        }
    }
);

// Fetch GstIn Setup Thunk
export const fetchGstInSetup = createAsyncThunk(
    'EinvoiceEwayBill/fetchGstInSetup',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/GstIn_view`);
            return response.data?.data || [];
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);

// Add GstIn Setup Thunk
export const GstIn_add = createAsyncThunk(
    'EinvoiceEwayBill/GstIn_add',
    async (values, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/GstIn_add/${values?.ClientID}`, values);

            return response.data?.data || [];
        } catch (error) {
            toast.error("Something went wrong while adding GSTIN");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to add GSTIN"
            );
        }
    }
);

// Update GstIn Setup Thunk
export const GstIn_Update = createAsyncThunk(
    'EinvoiceEwayBill/GstIn_Update',
    async ({ id, formData }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/GstIn_update/${id}`, formData);

            return response.data?.data || [];
        } catch (error) {
            toast.error("Something went wrong while updating GSTIN");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to update GSTIN"
            );
        }
    }
);

// Delete GstIn Setup Thunk
export const GstIn_Delete = createAsyncThunk(
    'EinvoiceEwayBill/GstIn_Delete',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/GstIn_delete/${id}`);

            return response.data;
        } catch (error) {
            toast.error("Something went wrong while deleting GSTIN");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to delete GSTIN"
            );
        }
    }
);

// Fetch EInvoice_EwayRegistrationDtl Thunk
export const fetchEInvoiceEwayRegistrationDtl = createAsyncThunk(
    'EinvoiceEwayBill/fetchEInvoiceEwayRegistrationDtl',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/EInvoice_EwayRegistrationDtl_view`);
            return response.data?.data || [];
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);

// Add EInvoice_EwayRegistrationDtl Thunk
export const EInvoice_EwayRegistrationDtl_Add = createAsyncThunk(
    'EinvoiceEwayBill/EInvoice_EwayRegistrationDtl_Add',
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/EInvoice_EwayRegistrationDtl_add/${formData?.id}`, formData);
            return response.data?.data || [];
        } catch (error) {
            toast.error("Something went wrong while adding EInvoice_EwayRegistrationDtl");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to add EInvoice_EwayRegistrationDtl"
            );
        }
    }
);

// Update EInvoice_EwayRegistrationDtl Thunk
export const EInvoice_EwayRegistrationDtl_Update = createAsyncThunk(
    'EinvoiceEwayBill/EInvoice_EwayRegistrationDtl_Update',
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/EInvoice_EwayRegistrationDtl_update/${formData.id}`, formData);
            return response.data?.data || [];
        } catch (error) {
            toast.error("Something went wrong while updating EInvoice_EwayRegistrationDtl");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to update EInvoice_EwayRegistrationDtl"
            );
        }
    }
);

// Delete EInvoice_EwayRegistrationDtl Thunk
export const EInvoice_EwayRegistrationDtl_Delete = createAsyncThunk(
    'EinvoiceEwayBill/EInvoice_EwayRegistrationDtl_Delete',
    async (MainID, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/EInvoice_EwayRegistrationDtl_delete/${MainID}`);
            return response.data?.data || [];
        } catch (error) {
            toast.error("Something went wrong while deleting EInvoice_EwayRegistrationDtl");
            return rejectWithValue(
                error.response?.data?.message || error.message || "Failed to delete EInvoice_EwayRegistrationDtl"
            );
        }
    }
);

// Fetch EInvoice_Eway Log Thunk
export const fetchEInvoiceEwayLog = createAsyncThunk(
    'EinvoiceEwayBill/fetchEInvoiceEwayLog',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/Einvoice_EWay_Log_View`);
            return response.data?.data || [];
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);

// Fetch EInvoice_Eway Response Thunk
export const fetchEInvoiceEwayResponse = createAsyncThunk(
    'EinvoiceEwayBill/fetchEInvoiceEwayResponse',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/EInvoice_Eway_Response_View`);
            return response.data?.data || [];
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);

// --- Redux Slice ---
const EinvoiceEwayBill = createSlice({
    name: 'EinvoiceEwayBill',
    initialState: {


        // Add New Client Scan Detail State
        EInvoiceEWaySetupMainData: [],
        EInvoiceEWaySetupMainLoading: false,
        EInvoiceEWaySetupMainError: null,

        EInvoiceEWaySetupDetailData: [],
        EInvoiceEWaySetupDetailLoading: false,
        EInvoiceEWaySetupDetailError: null,

        EInvoiceEwayRegisterData: [],
        EInvoiceEwayRegisterLoading: false,
        EInvoiceEwayRegisterError: null,

        GstInData: [],
        GstInLoading: false,
        GstInError: null,

        EInvoiceEwayRegisterDtlData: [],
        EInvoiceEwayRegisterDtlLoading: false,
        EInvoiceEwayRegisterDtlError: null,

        EInvoiceEwayLogData: [],
        EInvoiceEwayLogLoading: false,
        EInvoiceEwayLogError: null,

        EInvoiceEwayResponseData: [],
        EInvoiceEwayResponseLoading: false,
        EInvoiceEwayResponseError: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // --- Fetch EInvoice EWay Setup Main Data Handlers ---
            .addCase(fetchEInvoiceEWaySetupMainData.pending, (state) => {
                state.EInvoiceEWaySetupMainLoading = true;
                state.EInvoiceEWaySetupMainError = null;
            })
            .addCase(fetchEInvoiceEWaySetupMainData.fulfilled, (state, action) => {
                state.EInvoiceEWaySetupMainLoading = false;
                state.EInvoiceEWaySetupMainData = action.payload;
            })
            .addCase(fetchEInvoiceEWaySetupMainData.rejected, (state, action) => {
                state.EInvoiceEWaySetupMainLoading = false;
                state.EInvoiceEWaySetupMainError = action.payload;
            })


            // --- Add EInvoice EWay Setup Main Data Handlers ---
            .addCase(EInvoice_EWaySetupMain_add.pending, (state) => {
                state.EInvoiceEWaySetupMainLoading = true;
                state.EInvoiceEWaySetupMainError = null;
            })
            .addCase(EInvoice_EWaySetupMain_add.fulfilled, (state, action) => {
                state.EInvoiceEWaySetupMainLoading = false;
                // state.EInvoiceEWaySetupMainData = action.payload; // Typically re-fetch handles this, so we don't accidentally wipe array structure
            })
            .addCase(EInvoice_EWaySetupMain_add.rejected, (state, action) => {
                state.EInvoiceEWaySetupMainLoading = false;
                state.EInvoiceEWaySetupMainError = action.payload;
            })


            // --- Update EInvoice EWay Setup Main Data Handlers ---
            .addCase(EInvoice_EWaySetupMain_Update.pending, (state) => {
                state.EInvoiceEWaySetupMainLoading = true;
                state.EInvoiceEWaySetupMainError = null;
            })
            .addCase(EInvoice_EWaySetupMain_Update.fulfilled, (state, action) => {
                state.EInvoiceEWaySetupMainLoading = false;
            })
            .addCase(EInvoice_EWaySetupMain_Update.rejected, (state, action) => {
                state.EInvoiceEWaySetupMainLoading = false;
                state.EInvoiceEWaySetupMainError = action.payload;
            })


            // --- Delete EInvoice EWay Setup Main Data Handlers ---
            .addCase(EInvoice_EWaySetupMain_Delete.pending, (state) => {
                state.EInvoiceEWaySetupMainLoading = true;
                state.EInvoiceEWaySetupMainError = null;
            })
            .addCase(EInvoice_EWaySetupMain_Delete.fulfilled, (state, action) => {
                state.EInvoiceEWaySetupMainLoading = false;
            })
            .addCase(EInvoice_EWaySetupMain_Delete.rejected, (state, action) => {
                state.EInvoiceEWaySetupMainLoading = false;
                state.EInvoiceEWaySetupMainError = action.payload;
            })


            // --- Fetch EInvoice EWay Setup Detail Data Handlers ---
            .addCase(fetchEInvoiceEWaySetupDetail.pending, (state) => {
                state.EInvoiceEWaySetupDetailLoading = true;
                state.EInvoiceEWaySetupDetailError = null;
            })
            .addCase(fetchEInvoiceEWaySetupDetail.fulfilled, (state, action) => {
                state.EInvoiceEWaySetupDetailLoading = false;
                state.EInvoiceEWaySetupDetailData = action.payload;
            })
            .addCase(fetchEInvoiceEWaySetupDetail.rejected, (state, action) => {
                state.EInvoiceEWaySetupDetailLoading = false;
                state.EInvoiceEWaySetupDetailError = action.payload;
            })

            // --- Add EInvoice EWay Setup Detail Data Handlers ---
            .addCase(EInvoice_EWaySetupDetail_add.pending, (state) => {
                state.EInvoiceEWaySetupDetailLoading = true;
                state.EInvoiceEWaySetupDetailError = null;
            })
            .addCase(EInvoice_EWaySetupDetail_add.fulfilled, (state, action) => {
                state.EInvoiceEWaySetupDetailLoading = false;
            })
            .addCase(EInvoice_EWaySetupDetail_add.rejected, (state, action) => {
                state.EInvoiceEWaySetupDetailLoading = false;
                state.EInvoiceEWaySetupDetailError = action.payload;
            })

            // --- Update EInvoice EWay Setup Detail Data Handlers ---
            .addCase(EInvoice_EWaySetupDetail_Update.pending, (state) => {
                state.EInvoiceEWaySetupDetailLoading = true;
                state.EInvoiceEWaySetupDetailError = null;
            })
            .addCase(EInvoice_EWaySetupDetail_Update.fulfilled, (state, action) => {
                state.EInvoiceEWaySetupDetailLoading = false;
            })
            .addCase(EInvoice_EWaySetupDetail_Update.rejected, (state, action) => {
                state.EInvoiceEWaySetupDetailLoading = false;
                state.EInvoiceEWaySetupDetailError = action.payload;
            })

            // --- Delete EInvoice EWay Setup Detail Data Handlers ---
            .addCase(EInvoice_EWaySetupDetail_Delete.pending, (state) => {
                state.EInvoiceEWaySetupDetailLoading = true;
                state.EInvoiceEWaySetupDetailError = null;
            })
            .addCase(EInvoice_EWaySetupDetail_Delete.fulfilled, (state, action) => {
                state.EInvoiceEWaySetupDetailLoading = false;
            })
            .addCase(EInvoice_EWaySetupDetail_Delete.rejected, (state, action) => {
                state.EInvoiceEWaySetupDetailLoading = false;
                state.EInvoiceEWaySetupDetailError = action.payload;
            })

            // --- Fetch EInvoice EWay Setup Detail Data Handlers ---
            .addCase(fetchEinvoiceEwaySetupRegistration.pending, (state) => {
                state.EInvoiceEwayRegisterLoading = true;
                state.EInvoiceEwayRegisterError = null;
            })
            .addCase(fetchEinvoiceEwaySetupRegistration.fulfilled, (state, action) => {
                state.EInvoiceEwayRegisterLoading = false;
                state.EInvoiceEwayRegisterData = action.payload;
            })
            .addCase(fetchEinvoiceEwaySetupRegistration.rejected, (state, action) => {
                state.EInvoiceEwayRegisterLoading = false;
                state.EInvoiceEwayRegisterError = action.payload;
            })


            // --- Add Einvoice Eway Setup Registration Data Handlers ---
            .addCase(EInvoice_EwayRegistration_add.pending, (state) => {
                state.EInvoiceEwayRegisterLoading = true;
                state.EInvoiceEwayRegisterError = null;
            })
            .addCase(EInvoice_EwayRegistration_add.fulfilled, (state, action) => {
                state.EInvoiceEwayRegisterLoading = false;
                state.EInvoiceEwayRegisterData = action.payload;
            })
            .addCase(EInvoice_EwayRegistration_add.rejected, (state, action) => {
                state.EInvoiceEwayRegisterLoading = false;
                state.EInvoiceEwayRegisterError = action.payload;
            })

            // --- Update Einvoice Eway Setup Registration Data Handlers ---
            .addCase(EInvoice_EwayRegistration_update.pending, (state) => {
                state.EInvoiceEwayRegisterLoading = true;
                state.EInvoiceEwayRegisterError = null;
            })
            .addCase(EInvoice_EwayRegistration_update.fulfilled, (state, action) => {
                state.EInvoiceEwayRegisterLoading = false;
            })
            .addCase(EInvoice_EwayRegistration_update.rejected, (state, action) => {
                state.EInvoiceEwayRegisterLoading = false;
                state.EInvoiceEwayRegisterError = action.payload;
            })

            // --- Delete Einvoice Eway Setup Registration Data Handlers ---
            .addCase(EInvoice_EwayRegistration_delete.pending, (state) => {
                state.EInvoiceEwayRegisterLoading = true;
                state.EInvoiceEwayRegisterError = null;
            })
            .addCase(EInvoice_EwayRegistration_delete.fulfilled, (state, action) => {
                state.EInvoiceEwayRegisterLoading = false;
            })
            .addCase(EInvoice_EwayRegistration_delete.rejected, (state, action) => {
                state.EInvoiceEwayRegisterLoading = false;
                state.EInvoiceEwayRegisterError = action.payload;
            })

            // --- Fetch GstIn Data Handlers ---
            .addCase(fetchGstInSetup.pending, (state) => {
                state.GstInLoading = true;
                state.GstInError = null;
            })
            .addCase(fetchGstInSetup.fulfilled, (state, action) => {
                state.GstInLoading = false;
                state.GstInData = action.payload;
            })
            .addCase(fetchGstInSetup.rejected, (state, action) => {
                state.GstInLoading = false;
                state.GstInError = action.payload;
            })

            // --- Add GstIn Data Handlers ---
            .addCase(GstIn_add.pending, (state) => {
                state.GstInLoading = true;
                state.GstInError = null;
            })
            .addCase(GstIn_add.fulfilled, (state, action) => {
                state.GstInLoading = false;
                state.GstInData = action.payload;
            })
            .addCase(GstIn_add.rejected, (state, action) => {
                state.GstInLoading = false;
                state.GstInError = action.payload;
            })

            // --- Update GstIn Data Handlers ---
            .addCase(GstIn_Update.pending, (state) => {
                state.GstInLoading = true;
                state.GstInError = null;
            })
            .addCase(GstIn_Update.fulfilled, (state, action) => {
                state.GstInLoading = false;
                state.GstInData = action.payload;
            })
            .addCase(GstIn_Update.rejected, (state, action) => {
                state.GstInLoading = false;
                state.GstInError = action.payload;
            })

            // --- Delete GstIn Data Handlers ---
            .addCase(GstIn_Delete.pending, (state) => {
                state.GstInLoading = true;
                state.GstInError = null;
            })
            .addCase(GstIn_Delete.fulfilled, (state, action) => {
                state.GstInLoading = false;
            })
            .addCase(GstIn_Delete.rejected, (state, action) => {
                state.GstInLoading = false;
                state.GstInError = action.payload;
            })

            // --- Fetch EInvoiceEwayRegisterDtl Data Handlers ---
            .addCase(fetchEInvoiceEwayRegistrationDtl.pending, (state) => {
                state.EInvoiceEwayRegisterDtlLoading = true;
                state.EInvoiceEwayRegisterDtlError = null;
            })
            .addCase(fetchEInvoiceEwayRegistrationDtl.fulfilled, (state, action) => {
                state.EInvoiceEwayRegisterDtlLoading = false;
                state.EInvoiceEwayRegisterDtlData = action.payload;
            })
            .addCase(fetchEInvoiceEwayRegistrationDtl.rejected, (state, action) => {
                state.EInvoiceEwayRegisterDtlLoading = false;
                state.EInvoiceEwayRegisterDtlError = action.payload;
            })

            // --- Add EInvoiceEwayRegisterDtl Data Handlers ---
            .addCase(EInvoice_EwayRegistrationDtl_Add.pending, (state) => {
                state.EInvoiceEwayRegisterDtlLoading = true;
                state.EInvoiceEwayRegisterDtlError = null;
            })
            .addCase(EInvoice_EwayRegistrationDtl_Add.fulfilled, (state, action) => {
                state.EInvoiceEwayRegisterDtlLoading = false;
                state.EInvoiceEwayRegisterDtlData = action.payload;
            })
            .addCase(EInvoice_EwayRegistrationDtl_Add.rejected, (state, action) => {
                state.EInvoiceEwayRegisterDtlLoading = false;
                state.EInvoiceEwayRegisterDtlError = action.payload;
            })

            // --- Update EInvoiceEwayRegisterDtl Data Handlers ---
            .addCase(EInvoice_EwayRegistrationDtl_Update.pending, (state) => {
                state.EInvoiceEwayRegisterDtlLoading = true;
                state.EInvoiceEwayRegisterDtlError = null;
            })
            .addCase(EInvoice_EwayRegistrationDtl_Update.fulfilled, (state, action) => {
                state.EInvoiceEwayRegisterDtlLoading = false;
                state.EInvoiceEwayRegisterDtlData = action.payload;
            })
            .addCase(EInvoice_EwayRegistrationDtl_Update.rejected, (state, action) => {
                state.EInvoiceEwayRegisterDtlLoading = false;
                state.EInvoiceEwayRegisterDtlError = action.payload;
            })

            // --- Delete EInvoiceEwayRegisterDtl Data Handlers ---
            .addCase(EInvoice_EwayRegistrationDtl_Delete.pending, (state) => {
                state.EInvoiceEwayRegisterDtlLoading = true;
                state.EInvoiceEwayRegisterDtlError = null;
            })
            .addCase(EInvoice_EwayRegistrationDtl_Delete.fulfilled, (state, action) => {
                state.EInvoiceEwayRegisterDtlLoading = false;
            })
            .addCase(EInvoice_EwayRegistrationDtl_Delete.rejected, (state, action) => {
                state.EInvoiceEwayRegisterDtlLoading = false;
                state.EInvoiceEwayRegisterDtlError = action.payload;
            })

            // --- Fetch EInvoiceEwayLog Data Handlers ---
            .addCase(fetchEInvoiceEwayLog.pending, (state) => {
                state.EInvoiceEwayLogLoading = true;
                state.EInvoiceEwayLogError = null;
            })
            .addCase(fetchEInvoiceEwayLog.fulfilled, (state, action) => {
                state.EInvoiceEwayLogLoading = false;
                state.EInvoiceEwayLogData = action.payload;
            })
            .addCase(fetchEInvoiceEwayLog.rejected, (state, action) => {
                state.EInvoiceEwayLogLoading = false;
                state.EInvoiceEwayLogError = action.payload;
            })

            // --- Fetch EInvoiceEwayResponse Data Handlers ---
            .addCase(fetchEInvoiceEwayResponse.pending, (state) => {
                state.EInvoiceEwayResponseLoading = true;
                state.EInvoiceEwayResponseError = null;
            })
            .addCase(fetchEInvoiceEwayResponse.fulfilled, (state, action) => {
                state.EInvoiceEwayResponseLoading = false;
                state.EInvoiceEwayResponseData = action.payload;
            })
            .addCase(fetchEInvoiceEwayResponse.rejected, (state, action) => {
                state.EInvoiceEwayResponseLoading = false;
                state.EInvoiceEwayResponseError = action.payload;
            })
    }
});

// Export actions
export const {
} = EinvoiceEwayBill.actions;

// Export the reducer
export default EinvoiceEwayBill.reducer;